import { QueryErrorBoundary } from '@sara/ui/components/query-error-boundary';
import { HeaderBreadcrumbsContent } from './HeaderBreadcrumbsContent';

export function HeaderBreadcrumbsContainer() {
  // Errors here would be entity lookups for breadcrumb labels — not load-bearing
  // for the page itself, which fetches the same data with its own error boundary.
  // Render nothing on failure rather than escalating to the layout-wide error UI.
  return (
    <QueryErrorBoundary fallbackRender={() => null}>
      <HeaderBreadcrumbsContent />
    </QueryErrorBoundary>
  );
}
